import { useState, useMemo, useEffect } from 'react'
import { useRouter } from 'next/router'

import { TextField, Typography, makeStyles, Box } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import DeminimisList from './DeMinimisList'
import getDeMinimisData from './deMinimisData'

const LIMIT_ITEM = 14

const useStyles = makeStyles((theme) => ({
    seeAll: {
        color: theme.palette.primary.main,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        width: 'fit-content',
        margin: '30px auto 0'
    }
}))

const DeMinimis = () => {
    const classes = useStyles()

    const router = useRouter()

    const language = router.locale

    const data = getDeMinimisData(language)

    const [open, setOpen] = useState('')
    const [focusItems, setFocusItems] = useState(null)
    const [isSeeAll, setIsSeeAll] = useState(false)
    const [keyword, setKeyword] = useState(null)
    const [init, setInit] = useState(true)
 
    const options = useMemo(() => {
        const countries = data ? Object.keys(data) : []

        return countries
    }, [data])

    const handleClickCountry = (key) => {
        setOpen(key)
    }

    const handleClose = (e) => {
        e.stopPropagation()
        setOpen('')
    }

    const handleFilterData = (k, isAll) => {
        if (k) {
            const filter = data[k]

            if (filter) {
                setFocusItems({ [k]: { ...filter } })
            } else {
                setFocusItems(null)
            }
        } else if (!isAll) {
            const filter = Object.keys(data).reduce((acc, cur) => {
                if (Object.keys(acc).length <= LIMIT_ITEM) {
                    acc[cur] = { ...data[cur] }
                }

                return acc
            }, {})

            setFocusItems(filter)
        } else {
            setFocusItems(data)
        }
    }

    const handleSearch = (e, newValue) => {
        setOpen('')
        setKeyword(newValue)
        handleFilterData(newValue, isSeeAll)
    }

    const handleSeeAll = () => {
        setIsSeeAll(true)
        setKeyword(null)
        setOpen('')
        handleFilterData(null, true)
    }

    useEffect(() => {
        if (init) {
            handleFilterData(null, false)
            setInit(false)
        }
    }, [])

    return (
        <div>
            <Autocomplete 
                fullWidth
                autoHighlight
                options={options}
                value={keyword}
                onChange={handleSearch}
                renderInput={(params) => (
                    <TextField 
                        {...params}
                        margin="normal"
                        variant="outlined"
                        fullWidth
                        placeholder='Enter or select to search for a country.'
                        style={{ backgroundColor: 'white', borderRadius: 5 }}
                    />
                )}
            />
            
            {focusItems && (
                <>
                    <Typography>Countries</Typography>
                    <DeminimisList data={focusItems} open={open} onExpand={handleClickCountry} onClose={handleClose} />
                    {!isSeeAll && !keyword && (
                        <Box>
                            <Box className={classes.seeAll} onClick={handleSeeAll}>
                                <Typography>See all</Typography>
                                <KeyboardArrowDownIcon />
                            </Box>
                        </Box>
                    )}
                </>
            )}
        </div>
    )
}

export default DeMinimis